var $ = require('../internals/export');

var DESCRIPTORS = require('../internals/descriptors');

var defineProperties = require('../internals/object-define-properties'); // `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties


$({
  target: 'Object',
  stat: true,
  forced: !DESCRIPTORS,
  sham: !DESCRIPTORS
}, {
  defineProperties: defineProperties
});